
export default class Sorter {
  static sortBy(data, key, { sensitivity = true, reverse = false } = {}) {
    data = [...data]

    data.sort((obj, obj1) => {
      const val1 = obj[key] ? String(obj[key]) : ''
      const val2 = obj1[key] ? String(obj1[key]) : ''

      const value = sensitivity ? val1 : val1.toLowerCase()
      const value1 = sensitivity ? val2 : val2.toLowerCase()

      return value.localeCompare(value1, 'pt-BR', {sensitivity: 'base'})
    })

    return reverse ? data.reverse() : data
  }
}